import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import { UserListScreen } from "../screens/user/UserList.screen";
import { RouteConfig } from "./AuthRoutes";
const UserRoutes = () => {
  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "list",
    element: /*#__PURE__*/React.createElement(UserListScreen, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: RouteConfig.user.list,
      replace: true
    })
  }));
};
export { UserRoutes };